import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

const internalApi = axios.create({
  baseURL,
});

internalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("internal_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

internalApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("internal_token");
      localStorage.removeItem("internal_user");
      if (window.location.pathname.startsWith("/internal") && window.location.pathname !== "/internal/login") {
        window.location.href = "/internal/login";
      }
    }
    return Promise.reject(error);
  }
);

export default internalApi;
